import { Pipe, PipeTransform } from '@angular/core';
import { isVirtualGridGroup } from '../types/virtual-grid-group';

@Pipe({
  name: 'isVirtualGridGroup'
})
export class IsVirtualGridGroupPipe implements PipeTransform {
  transform(value: any): boolean {
    return isVirtualGridGroup(value);
  }
}
